<app-station-tile class="station-item" styleClass="empty-working-station" [isDisabled]="station.stationUsage.disabled"
  [suspended]="station.stationUsage.suspended" [selected]="selected"
  *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 0">

  <sc-padding>
    <sc-flex>
      <sc-icon iconClass="fa-lock" *ngIf="station?.stationUsage?.suspended"></sc-icon>
      <sc-icon iconClass="fa-xmark" *ngIf="station?.stationUsage?.disabled"></sc-icon>
      <sc-content-spacer></sc-content-spacer>
      <div class="label">{{station.name}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>

<app-station-tile class="station-item" styleClass="used-working-station" [selected]="selected"
  *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 1">

  <sc-padding>
    <sc-flex>
      <sc-icon iconClass="fa-truck" *ngIf="station?.stationUsage?.transports.length > 0"></sc-icon>
      <sc-content-spacer></sc-content-spacer>
      <div class="label">{{station.name}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>

<app-station-tile class="station-item" styleClass="waiting-area" [selected]="selected"
  *ngIf="station.stationType === stationType.WAITING_AREA">

  <sc-padding>
    <sc-flex>
      <sc-icon iconClass="fa-lock" *ngIf="station?.stationUsage?.suspended"></sc-icon>
      <sc-icon iconClass="fa-xmark" *ngIf="station?.stationUsage?.disabled"></sc-icon>
      <sc-content-spacer></sc-content-spacer>
      <div class="label">{{station.name}}</div>
      <sc-content-spacer></sc-content-spacer>
      <div>{{station?.stationUsage?.transports?.length}} / {{station?.capacity}}</div>
    </sc-flex>
  </sc-padding>

</app-station-tile>
